import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container footer-content">
        <p>© {year} [pavant.dev] All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
